import React from 'react';

import {observer} from "mobx-react";
import {ScoresBarWidgetToolbarFilterOddsButton} from "../../scores-bar-widget/components/conditional/scores-bar-widget.toolbar.filter.odds-button";
import styles from "../styles/entity-scores-widget.module.scss";
import classNames from "classnames";

export const EntityScoresWidgetHeaderOddsToggle = observer(({controller}) => {
  const {state: {shouldRenderShowOddsToggle}} = controller;

  const oddsToggleProps = {
    controller,
    className: classNames(styles.odds_toggle)
  }

  return <div className={classNames(styles.odds_toggle_container)}>
    {
      shouldRenderShowOddsToggle ? <ScoresBarWidgetToolbarFilterOddsButton {...oddsToggleProps}/> : null
    }
  </div>
});